import React, { useEffect, useState } from "react";
import "./AdminSupport.css";
import { GetUserDetails } from "../../../Helpers/Utility";
import {  postData } from "../../../Services/Api";
import SearchIcon from "../../../Assets/Images/SearchIcon.png";
// import { confirmAlert } from "react-confirm-alert";
// import { toast } from "react-toastify";
import "react-confirm-alert/src/react-confirm-alert.css";
import { ColorRing } from "react-loader-spinner";

export default function AdminSupport() {
  const [supportRequests, setSupportRequests] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [recordCount, setRecordCount] = useState(0);
  // const [editModalOpen, setEditModalOpen] = useState(false);
  // const [selectedRequest, setSelectedRequest] = useState(null);
  // const [userToken, setUserToken] = useState("");
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false); 

  const [timeOutId, setTimeoutId] = useState(-1);

  const requestsPerPage = 10;

  const getSupportRequests = async (token, page, search) => {
    if (!token) return;

    // setUserToken(token);

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    const data = {
      search_text: search || "",
      page_number: page,
      limit: requestsPerPage,
      sortBy: "created_at",
      sortAscDesc: "desc",
    };

    setLoading(true);
    const getDataResponse = await postData("user-support-request-list", data, headers);
    setLoading(false);

    const { data: supportData, currentPage, recordCount, totalPageCount } =
      getDataResponse?.data?.data || {};
    setSupportRequests(supportData || []);
    setCurrentPage(currentPage || 1);
    setRecordCount(recordCount || 0);
    setTotalPages(totalPageCount || 1);
  };

  useEffect(() => {
    const userDetails = GetUserDetails();
    if (userDetails?.token) {
      getSupportRequests(userDetails.token, currentPage, searchText);
    }
  }, [currentPage, searchText]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // const handleEditClick = (request) => {
  //   setSelectedRequest(request);
  //   setEditModalOpen(true);
  // };

  // const handleClose = () => {
  //   setSelectedRequest(null);
  //   setEditModalOpen(false);
  // };

  // const updateRequestList = async () => {
  //   const userDetails = GetUserDetails();
  //   if (userDetails?.token) {
  //     await getSupportRequests(userDetails?.token, currentPage);
  //   }
  // };

  const handleSearchChange = (e) => {
     if (timeOutId) clearTimeout(timeOutId);
     setTimeoutId(
       setTimeout(() => {
         setSearchText(e.target.value);
         setCurrentPage(1); // Reset to first page on search
       }, 500)
     );
  };

  // const handleDeleteClick = (requestId) => {
  //   const userDetails = GetUserDetails();
  //   if (!userDetails?.token) {
  //     return;
  //   }

  //   const headers = {
  //     Authorization: `Bearer ${userDetails.token}`,
  //   };

  //   confirmAlert({
  //     title: "Confirm to delete",
  //     message: "Are you sure to delete this support request?",
  //     buttons: [
  //       {
  //         label: "Yes",
  //         onClick: async () => {
  //           try {
  //             const sendData = {
  //               request_id: requestId,
  //               is_deleted: 1,
  //             };

  //             const getDataResponse = await deleteData(
  //               "delete-support-request",
  //               sendData,
  //               headers
  //             );

  //             if (getDataResponse.success) {
  //               setSupportRequests((prevRequests) =>
  //                 prevRequests.filter((request) => request.id !== requestId)
  //               );
  //               toast.success("Support request deleted successfully");
  //             } else {
  //               console.error(
  //                 "Failed to delete support request:",
  //                 getDataResponse.message
  //               );
  //               toast.error("Failed to delete support request");
  //             }
  //           } catch (error) {
  //             console.error("Error deleting support request:", error);
  //             toast.error(
  //               "An error occurred while deleting the support request"
  //             );
  //           }
  //         },
  //       },
  //       {
  //         label: "No",
  //         onClick: () => console.log("Delete cancelled"),
  //       },
  //     ],
  //   });
  // };

  const indexOfLastRequest = currentPage * requestsPerPage;
  const indexOfFirstRequest = indexOfLastRequest - requestsPerPage;

  const renderPagination = () => {
    const pageNumbers = [];
    const maxPagesToShow = 5;

    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      const startPages = [1];
      const endPages = [totalPages];
      let middlePages = [];

      if (currentPage <= 3) {
        middlePages = [2, 3, 4];
      } else if (currentPage >= totalPages - 2) {
        middlePages = [totalPages - 3, totalPages - 2, totalPages - 1];
      } else {
        middlePages = [currentPage - 1, currentPage, currentPage + 1];
      }

      pageNumbers.push(...startPages);

      if (middlePages[0] > 2) {
        pageNumbers.push("...");
      }

      pageNumbers.push(...middlePages);

      if (middlePages[middlePages.length - 1] < totalPages - 1) {
        pageNumbers.push("...");
      }

      pageNumbers.push(...endPages);
    }

    return pageNumbers.map((page, index) =>
      typeof page === "number" ? (
        <li
          key={index}
          className={`page-item ${currentPage === page ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(page)}>
            {page}
          </button>
        </li>
      ) : (
        <li key={index} className="page-item disabled">
          <span className="page-link">{page}</span>
        </li>
      )
    );
  };

  return (
    <section className="AdminSupport px-3">
      <div className="AdminSupportTable">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-block w-100 headingAdmin py-3">
            <h2 className="">Support</h2>
          </div>
          <div className="input-group justify-content-end">
            <span className="input-group-text border-end-0 rounded-start-5 bg-white">
              <img src={SearchIcon} alt="Search" className="img-fluid" />
            </span>
            <input
              type="text"
              className="form-control searchTextBox rounded-end-5 border-start-0"
              style={{ maxWidth: "300px" }}
              placeholder="Search Here..."
              // value={searchText}
              onChange={handleSearchChange}
            />
          </div>
        </div>
        <div className="AdminSupportTableSection bg-white p-2 px-0 rounded-4">
        {loading ? (
            <div className="d-flex justify-content-center py-5">
              <ColorRing
                type="ThreeDots"
                color="#00BFFF"
                height={80}
                width={80}
              />
            </div>
          ) : (
           <div className='table-responsive'>

<table className="table">
            <thead>
              <tr>
                <th className="customTh" scope="col">
                  S.no
                </th>
                <th className="customTh" scope="col">
                  Name
                </th>
                <th className="customTh" scope="col">
                  Email
                </th>
                <th className="customTh" scope="col">
                  Comments
                </th>
                {/* <th className="customTh" scope="col">
                  Created At
                </th>
                <th className="customTh" scope="col">
                  Action
                </th> */}
              </tr>
            </thead>
            <tbody>
              {supportRequests.map((request, index) => (
                <tr key={index}>
                  {/* <td className="customTd">{index + 1}</td> */}
                  <td className="customTd">{request.index}</td>
                  <td className="customTd">{request.name}</td>
                  <td className="customTd">{request.email}</td>
                  <td className="customTd">{request.comments}</td>
                  {/* <td className="customTd">{request.created_at}</td>
                  <td className="customTd">
                    <div className="d-flex align-items-center">
                      <div
                        className="mx-2 mt-1 cursor-pointer"
                        onClick={() => handleEditClick(request)}
                      >
                        <i className="fa fa-edit editColor" />
                      </div>
                      <div
                        className="mx-1 cursor-pointer"
                        onClick={() => handleDeleteClick(request?.id)}
                      >
                        <i className="fa fa-trash trashColor" />
                      </div>
                    </div>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
</div>
          )}
          <div className="px-4 d-flex py-2 align-items-center justify-content-between flexColumn my3">
            <div className="d-flex pageCountColor my3">
              Showing
              <span className="ps-1 pageCountColor">
                {indexOfFirstRequest + 1}-{Math.min(indexOfLastRequest, recordCount)}{" "}
                of {recordCount}
              </span>
            </div>
            <nav aria-label="Page navigation example">
              <ul className="pagination">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    <i
                      className="fa fa-angle-left text-black"
                      aria-hidden="true"
                    ></i>
                  </button>
                </li>
                {renderPagination()}
                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    <i
                      className="fa fa-angle-right text-black"
                      aria-hidden="true"
                    ></i>
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </section>
  );
}
